<template>
  <div id="app">
    <div class="head">
      <div class="head_container">
        <div class="main_center">
          <router-link to="/" class="nav-link"
            ><div class="head_left_t">
              <img
                src="../assets/image/headlogo.png"
                alt="头部logo"
                :style="{ maxWidth: '100%', height: 'auto' }"
              /></div
          ></router-link>

          <div class="head_right">
            <nav>
              <ul class="seven_order">
                <li class="li_1">
                  <router-link to="/" class="nav-link">首页</router-link>
                </li>
                <li class="li_1">
                  <router-link to="/ProductCenter/0" class="nav-link"
                    >产品中心</router-link
                  >
                  <ul class="subnav">
                    <router-link to="/ProductCenter/5">
                      <li>智慧管控平台</li></router-link
                    >
                    <router-link to="/ProductCenter/2">
                      <li>净化类设备</li></router-link
                    >
                    <router-link to="/ProductCenter/3">
                      <li>在线监测系统</li></router-link
                    >
                    <router-link to="/ProductCenter/4">
                      <li>洁净室检测</li></router-link
                    >
                    <router-link to="/ProductCenter/1">
                      <li>洁净检测仪器</li></router-link
                    >
                  </ul>
                </li>
                <li class="li_1">
                  <router-link to="/AboutUs" class="nav-link">
                    关于我们</router-link
                  >
                  <ul class="subnav">
                    <router-link
                      :to="{
                        name: 'AboutUs',
                        query: { scrollTo: 'section1' },
                      }"
                    >
                      <li>公司简介</li>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'AboutUs',
                        query: { scrollTo: 'section2' },
                      }"
                    >
                      <li>组织架构</li>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'AboutUs',
                        query: { scrollTo: 'section3' },
                      }"
                    >
                      <li>企业文化</li>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'AboutUs',
                        query: { scrollTo: 'section4' },
                      }"
                    >
                      <li>资质证书</li>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'AboutUs',
                        query: { scrollTo: 'section5' },
                      }"
                    >
                      <li>售后服务承诺书</li>
                    </router-link>
                  </ul>
                </li>
                <li class="li_1">
                  <router-link to="/CustomerCase" class="nav-link"
                    >客户案例</router-link
                  >
                  <ul class="subnav">
                    <router-link
                      :to="{
                        name: 'CustomerCase',
                        query: { scrollTo: 'sectionA' },
                      }"
                    >
                      <li>客户名单</li>
                    </router-link>
                  </ul>
                </li>
                <li class="li_1">
                  <router-link to="/ValueAddedServices" class="nav-link"
                    >增值服务</router-link
                  >
                  <ul class="subnav">
                    <router-link
                      :to="{
                        name: 'ValueAddedServices',
                        query: { scrollTo: 'sectionA' },
                      }"
                    >
                      <li>信息运维</li>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'ValueAddedServices',
                        query: { scrollTo: 'sectionA' },
                      }"
                    >
                      <li>智能产线</li>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'ValueAddedServices',
                        query: { scrollTo: 'sectionA' },
                      }"
                    >
                      <li>智能工厂</li>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'ValueAddedServices',
                        query: { scrollTo: 'sectionA' },
                      }"
                    >
                      <li>洁净室验证</li>
                    </router-link>
                    <!-- <li>信息运维</li>
                    <li>智能产线</li>
                    <li>智能工厂</li>
                    <li>洁净室验证</li> -->
                  </ul>
                </li>
                <li class="li_1">
                  <router-link to="/NewsCenter" class="nav-link"
                    >新闻中心</router-link
                  >
                  <ul class="subnav">
                    <router-link
                      :to="{
                        name: 'NewsCenter',
                        query: { scrollTo: 'sectionA' },
                      }"
                    >
                      <li>公司新闻</li>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'NewsCenter',
                        query: { scrollTo: 'sectionB' },
                      }"
                    >
                      <li>行业资讯</li>
                    </router-link>
                  </ul>
                </li>
                <li class="li_1">
                  <router-link to="/ContactUs" class="nav-link"
                    >联系我们</router-link
                  >
                  <ul class="subnav">
                    <router-link
                      :to="{
                        name: 'ContactUs',
                        query: { scrollTo: 'sectionA' },
                      }"
                    >
                      <li>联系方式</li>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'ContactUs',
                        query: { scrollTo: 'sectionB' },
                      }"
                    >
                      <li>在线留言</li>
                    </router-link>
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <ul class="menu">
      <router-link to="/" class="nav-link">
        <li class="menu-item">首页</li></router-link
      >
      <router-link to="/ProductCenter/0" class="nav-link">
        <li class="menu-item">产品中心</li></router-link
      >
      <router-link to="/AboutUs" class="nav-link">
        <li class="menu-item">关于我们</li></router-link
      >
      <router-link to="/CustomerCase" class="nav-link">
        <li class="menu-item">客户案例</li></router-link
      >
      <router-link to="/ValueAddedServices" class="nav-link">
        <li class="menu-item">增值服务</li></router-link
      >
      <router-link to="/NewsCenter" class="nav-link">
        <li class="menu-item">新闻中心</li></router-link
      >
      <router-link to="/ContactUs" class="nav-link">
        <li class="menu-item">联系我们</li></router-link
      >
    </ul>

    <router-view></router-view>

    <!-- <div class="live-chat-button-container">
      <button @click="openLiveChat">
        <img
          src="../assets/image/在线客服.png"
          alt="在线客服"
          style="width: 30px; height: 30px; margin-bottom: -16px"
        />
        在线客服
      </button>
    </div> -->

    <LiveChat ref="liveChat" />

    <!-- footer -->
    <footer style="display: flex; flex-direction: column">
      <div class="foot_main_body">
        <div class="head_left" style="margin-top: -81px; margin-left: -6px">
          <img src="../assets/image/btmlogo.png" alt="尾部logo" />
        </div>
        <div
          class="foot_main_body_right"
          style="
            display: flex;
            flex-direction: row;
            width: 75%;
            justify-content: space-around;
          "
        >
          <div>
            <dl class="div_right_1">
              <router-link to="/ValueAddedServices" class="nav-link-serve"
                ><dt>增值服务</dt></router-link
              >
              <router-link to="/ValueAddedServices" class="nav-link-serve">
                <dd>
                  <span class="span">信息运维</span>
                </dd></router-link
              >
              <router-link to="/ValueAddedServices" class="nav-link-serve"
                ><dd>
                  <span class="span">智能产线</span>
                </dd></router-link
              >
              <router-link to="/ValueAddedServices" class="nav-link-serve">
                <dd>
                  <span class="span">智能工厂 </span>
                </dd></router-link
              >
              <router-link to="/ValueAddedServices" class="nav-link-serve"
                ><dd>
                  <span class="span_4">洁净室验证</span>
                </dd>
              </router-link>
            </dl>
          </div>
          <div>
            <dl class="div_right_1">
              <router-link to="/AboutUs" class="nav-link-serve">
                <dt>关于我们</dt></router-link
              >
              <router-link to="/AboutUs" class="nav-link-serve">
                <dd>
                  <span class="span">公司简介</span>
                </dd></router-link
              >
              <router-link to="/AboutUs" class="nav-link-serve">
                <dd>
                  <span class="span">组织架构</span>
                </dd></router-link
              >
              <router-link to="/AboutUs" class="nav-link-serve">
                <dd>
                  <span class="span">企业文化 </span>
                </dd></router-link
              >
              <router-link to="/AboutUs" class="nav-link-serve">
                <dd>
                  <span class="span">资质证书</span>
                </dd></router-link
              >
            </dl>
          </div>
          <div>
            <dl class="div_right_1">
              <router-link to="/NewsCenter" class="nav-link-serve">
                <dt>新闻中心</dt></router-link
              >
              <router-link to="/NewsCenter" class="nav-link-serve">
                <dd>
                  <span class="span">公司新闻</span>
                </dd></router-link
              >
              <router-link to="/NewsCenter" class="nav-link-serve">
                <dd>
                  <span class="span">行业资讯</span>
                </dd></router-link
              >
            </dl>
          </div>
          <div>
            <dl class="div_right_1">
              <router-link to="/ContactUs" class="nav-link-serve"
                ><dt>联系我们</dt></router-link
              >
              <router-link to="/ContactUs" class="nav-link-serve"
                ><dd>
                  <span class="span">江苏君成智慧洁净科技有限公司</span>
                </dd></router-link
              >
              <router-link to="/ContactUs" class="nav-link-serve"
                ><dd>
                  <span class="span">联系人: 吴经理</span>
                </dd></router-link
              >
              <router-link to="/ContactUs" class="nav-link-serve"
                ><dd>
                  <span class="span">手机号: 18100681818 </span>
                </dd></router-link
              >
              <router-link to="/ContactUs" class="nav-link-serve"
                ><dd>
                  <span class="span">电话: 0512-65165589</span>
                </dd></router-link
              >
              <router-link to="/ContactUs" class="nav-link-serve"
                ><dd>
                  <span class="span">网址: www.jcgyzn.com</span>
                </dd></router-link
              >
              <router-link to="/ContactUs" class="nav-link-serve"
                ><dd>
                  <span class="span">地址: 苏州市吴江区云创路229号2层</span>
                </dd></router-link
              >
            </dl>
          </div>
        </div>
      </div>
      <div class="foot_body">
        <span>
          版权所有 © 江苏君成智慧洁净科技有限公司 COPYRIGHT 2024 ALL RIGHT
          RESERVED
        </span>
        <a href="https://beian.miit.gov.cn/" target="_blank"
          >苏ICP备2024091177号</a
        >
      </div>
    </footer>
  </div>
</template>

<script>
import LiveChat from "./LiveChatView.vue";
import { getDicList } from "@/api";
export default {
  components: {
    LiveChat,
  },
  name: "App",
  data() {
    return {
      pic: [
        { url: require("../assets/image/智慧存享.jpg") },
        { url: require("../assets/image/智慧洁净室服务商.jpg") },
        { url: require("../assets/image/sevenone.png") },
      ],
      selectedOption: "",
      items: [
        { name: "仪器1", description: "浮游菌采样器JC-6FT" },
        {
          name: "仪器2",
          description:
            "大/小流量尘埃粒子计数器JC-601T/JC-610T/JC-650T/JC-6100T",
        },
        { name: "仪器3", description: "手持式尘埃粒子计数器JC-601H" },
        // 其他仪器的名称和描述信息依此类推
      ],
      showDropdown: false,
      options: [],
    };
  },
  created() {
    this.cotegoryOptions();
  },
  mounted() {},
  methods: {
    openLiveChat() {
      this.$refs.liveChat.openChat();
    },
    handleMouseEnter() {
      this.showDropdown = true;
    },
    handleMouseLeave() {
      this.showDropdown = false;
    },
    handleSelectChange() {
      // 使用编程式导航跳转，并动态传递参数
      this.$router.push({
        name: "ProductCenter",
        params: { id: this.selectedOption },
      });
    },

    cotegoryOptions() {
      getDicList("productcategory")
        .then((res) => {
          if (res.code === "200") {
            console.log(res);
            this.options = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goToSection(section) {
      this.$router.push({ path: "/AboutUs" }).then(() => {
        // 页面跳转后，执行滚动操作
        this.$nextTick(() => {
          const element = document.getElementById(section);
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
        });
      });
    },
  },
};
</script>

<style>
@media (max-width: 1366px) {
  .head_left_t img {
    display: none;
  }
  .menu {
    font-size: 19px !important;
  }
}
@media (min-width: 966px) {
  .menu {
    display: none;
  }
  .head_left {
    display: none;
  }
}
@media (max-width: 966px) {
  .head_left_t img {
    display: block;
  }
  .foot_main_body {
    padding: 6.27rem 0 0.91rem !important;
  }
  .head_right {
    display: none !important;
    /* flex-direction: column !important; */
  }
  .foot_main_body {
    display: flex;
    flex-direction: column !important;
    margin-top: 50px;
    margin-left: 53px !important;
  }
  dt {
    font-size: 13px;
    padding: 3px;
  }
  span {
    font-size: 9px !important;
  }
  .menu {
    list-style-type: none;
    padding: 0;
    width: 100%;
  }
  .head_left img {
    display: none;
  }
  .foot_main_body_right {
    width: 80% !important;
    margin-left: 10px !important;
  }
  .menu-item {
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    margin-bottom: 10px;
    padding: 10px;
    font-size: 16px;
    text-align: center;
    transition: background-color 0.3s ease;
  }

  .menu-item:hover {
    background-color: #f0f0f0;
  }

  .menu-item a {
    text-decoration: none;
    color: #333;
    font-weight: bold;
    transition: color 0.3s ease;
  }

  .menu-item a:hover {
    color: #666;
  }
}
/* 默认样式，适用于宽度大于760px的浏览器 */
/* 媒体查询，适用于宽度小于或等于760px的浏览器 */
@media (max-width: 760px) {
  .subnav {
    display: none; /* 在小屏幕上隐藏导航栏 */
  }
}
.subnav li:first-child {
  border-top: none;
}
.subnav li {
  padding: 10px; /* 为子菜单项添加内边距 */
  border-bottom: 1px solid #ccc; /* 可选的子菜单项分隔线 */
  width: 140px; /* 设置子菜单项的宽度 */
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏溢出内容 */
  text-overflow: ellipsis; /* 用省略号表示被截断的文本 */
  padding: 0;
  border-bottom: 1px solid #ccc;
  font-size: 1vw;
}
.subnav li:last-child {
  border-bottom: none;
}
.subnav li:last-child {
  border-bottom: none; /* 移除最后一个子菜单项的下边框 */
}

/* 可选：为链接添加样式 */
.nav-link {
  text-decoration: none; /* 移除下划线 */
  color: #333; /* 链接颜色 */
  width: 140px;
}

.nav-link:hover {
  color: #f00; /* 鼠标悬停时的链接颜色 */
}
.seven_order li:hover .subnav {
  display: block;
  left: 50%; /* 将子菜单左边缘移动到父菜单的中心 */
  transform: translateX(
    -50%
  ); /* 将子菜单自身向左移动其自身宽度的50%，以使其居中 */
}
.seven_order li .subnav {
  position: absolute; /* 使用绝对定位来显示子菜单 */
  top: 98%; /* 子菜单出现在父元素的下方 */
  left: 50%; /* 子菜单与父元素左对齐 */
  transform: translateX(-50%);
  display: none; /* 默认隐藏子菜单 */
  list-style: none; /* 移除默认的列表样式 */
  padding: 0; /* 移除默认的padding */
  margin: 0; /* 移除默认的margin */
  background-color: rgb(44, 133, 212);
  border: 1px solid #2d0303; /* 可选的边框样式 */
  /* padding-top: 0; */
  border-top: none;
  /* width: 150px; */
  /* height: 150px; */
}
.seven_order li {
  position: relative;
  display: inline-block;
  /* width: 120px; */
  height: 70px;
  line-height: 70px;
  text-align: center;
  vertical-align: top;
}
* {
  margin: 0;
  padding: 0;
}
.subnav {
  display: none;
}

.foot_body {
  /* white-space: nowrap; */
  text-align: center;
  color: #fff;
  font-size: 1vw;
  padding: 0.91rem 0;
  margin-top: -12px;
  border-top: 0.05rem solid rgba(255, 255, 255, 0.1);
}
i {
  margin-left: 3px;
}
.span {
  margin-left: -22px;
  font-size: 1vw;
  /* margin-left: -21px;
  font-size: 1em; */
}
.span_4 {
  margin-left: -21px;
  font-size: 1vw;
  /* margin-left: -20px;
  font-size: 1em; */
}
.div_right_1 {
  white-space: nowrap;
  margin: 0;
  padding: 0;
  border: 0;
  width: 100%;
  height: auto;
  font-size: 1vw;
  color: #fff;
  outline: none;
  box-sizing: border-box;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}
dd {
  white-space: nowrap;
  margin: 18px;
  padding: 0;
  border: 0;
  outline: none;
  box-sizing: border-box;
  display: block;
  margin-inline-start: 40px;
}

a {
  margin: 0;
  padding: 0;
  border: 0;
  color: #fff;
  font-size: 1vw;
  vertical-align: baseline;
  outline: none;
  box-sizing: border-box;
  text-decoration: none;
}
dt {
  margin: 0;
  padding: 11;
  border: 0;
  outline: none;
  box-sizing: border-box;
  display: block;
}
.pic img {
  object-fit: contain;
  image-rendering: pixelated;
  width: 100%;
  height: auto;
  margin-left: 25px;
}
.pic {
  width: 40%;
  height: auto;
}
.wechat {
  text-align: right;
  display: flex;
  justify-content: flex-end;
  padding-right: 1.82rem;
  margin-top: 10px;
}
.footer_logo {
  width: 8.77rem;
  height: 2.27rem;
  margin-bottom: 0.91rem;
}
.foot_main_body {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 2.27rem 0 0.91rem;
  width: 90%;
  margin: 0 auto;
}
footer {
  display: block;
  margin-bottom: 0;
  background-color: rgb(44, 133, 212);
}
.li_2 > a {
  position: relative;
  padding-left: 0.91rem;
  font-size: 1vw;
  color: #fff;
}
.about_us {
  display: flex;
  justify-content: space-around;
  height: 100%;
  position: relative;
}
.about_us::before {
  content: "";
  width: 100%;
  height: 0.05rem;
  position: absolute;
  left: 0;
  right: 0;
  top: 1.95rem;
  background-color: rgba(255, 255, 255, 0.1);
}
.nav_layer_container {
  display: none;
  height: 106px;
  padding-top: 41px;
  margin-top: 0px;
  padding-bottom: 49.94px;
  margin-bottom: 0px;
  padding: 1.82rem 0 2.27rem;
  background-color: rgba(0, 0, 0, 0.85);
  overflow: hidden;
}
.nav_layer_container:hover {
  display: block;
  height: 106px;
  padding-top: 41px;
  margin-top: 0px;
  padding-bottom: 49.94px;
  margin-bottom: 0px;
  padding: 1.82rem 0 2.27rem;
  background-color: rgba(0, 0, 0, 0.85);
  overflow: hidden;
}
.nav_layer {
  display: none;
  opacity: 0;
  transition: opacity 0.3s ease; /* 添加过渡效果 */
}
.nav_layer.show {
  display: block;
  opacity: 1; /* 鼠标悬停时设置透明度为1，表示完全可见 */
}
.li_1 > a {
  white-space: nowrap;
  position: relative;
  padding: 0 1.36rem;
  height: 4.09rem;
  display: inline-block;
  line-height: 4.09rem;
  font-size: 16px;
  color: inherit;
  text-decoration: none;
}
.li_1 {
  color: #fff;
}
.li_1 :hover {
  background-color: rgb(32, 214, 129);
}
.li_1 > a::before {
  content: "";
  position: absolute;
  left: 0;
  top: -4.09rem;
  width: 0.05rem;
  height: 4.09rem;
  background: linear-gradient(to top, transparent, #fff, transparent);
  opacity: 0;
  transition: all 0.5s;
}
.li_1 > a:hover::before {
  top: 50%;
  transform: translateY(-50%);
  opacity: 1;
  transition: all 0.6s;
}
.li_1 > a:hover::after {
  bottom: 50%;
  transform: translateY(50%);
  opacity: 1;
  transition: all 0.6s;
}
.li_1 > a::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: -4.09rem;
  width: 0.05rem;
  height: 4.09rem;
  background: linear-gradient(to top, transparent, #fff, transparent);
  opacity: 0;
  transition: all 0.5s;
}
.seven_order {
  display: flex;
  align-items: center;
  justify-content: space-between;
  list-style: none;
  padding: 0;
  margin: 0;
}
nav {
  display: block;
  margin-right: 60px;
}
.main_center {
  height: 100%;
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  align-items: center;
  justify-content: space-between;
  background-color: rgb(44, 133, 212);
}
* {
  margin: 0;
  padding: 0;
}
ul {
  list-style: none;
}

.head_container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  height: 4.12rem;
  border-bottom: 0.05rem solid rgba(255, 255, 255, 0.1);
  background-color: rgb(44, 133, 212);
}
.head_left_t {
  display: flex;
  align-items: center;
  width: 350px;
  margin-left: 23px;
  justify-content: space-between;
}
.head_left {
  display: flex;
  align-items: center;
  width: 286px;
  justify-content: space-between;
}
/* .logo_name {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 22px;
  color: #fff;
  margin-left: 10px;
} */
/* .logo_name_bottom {
  font-size: 12px;
} */
/* .logo {
  width: 56px;
  height: 56px;
  line-height: 56px;
} */
.head_right {
  display: flex;
  align-items: center;
  font-size: 1vw;
  color: inherit;
}
img {
  width: 100%;
}
#app {
  width: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  background-color: #f8f8f8;
}
.nav-link-serve:hover {
  color: rgb(32, 214, 129);
}
</style>
